import { useRoutes } from "react-router-dom";
import AuthRoutes from "./AuthRoutes";
import BaseRoutes from "./BaseRoutes";
import CustomerRoutes, { CustomerAltRoutes } from "./CustomerRoutes";
import DashboardRoutes from "./DashboardRoutes";
import NoAuthRoutes, { PaymentsRoutes } from "./NoAuthRoutes";

const AppRoutes = () => {
    return useRoutes([BaseRoutes, NoAuthRoutes, PaymentsRoutes, AuthRoutes, DashboardRoutes, CustomerRoutes, CustomerAltRoutes]);

}

export default AppRoutes;